export default "/_next/static/images/service-cfa-desktop-2x-a44a28b2353a3a88cf7e1a71d26ace05.jpg";